/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TermsAndConditionsSharedService {

    /**
     * @param page
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTermsAndConditionsActiveTermsAndConditions(
        page?: string,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/terms-and-conditions/active-terms-and-conditions',
            query: {
                'page': page,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param termsAndConditionsId
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppTermsAndConditionsDownloadDocumentByParticipant(
        termsAndConditionsId: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/terms-and-conditions/download-document-by-participant/{termsAndConditionsId}',
            path: {
                'termsAndConditionsId': termsAndConditionsId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
